import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Box';
import languageStrings from '../utils/languages/languages';
import Footer from '../components/Footer';

interface IRegistrationLinkInfo {
    companyKey: string;
}

function RegistrationLinkInfo(props: IRegistrationLinkInfo){
    const generalRegistrationURL = `/publicRegister.do?companyKey=${props.companyKey}`;
    return (
        <div style={{
            width: '800px', 
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-200px',
            marginLeft: '-400px',
            height: '400px'
        }}>
            <Paper>
                <Typography align="center" variant="h4">{languageStrings.registrationLinkExpired.headerText}</Typography>
                <br/>
                <br/>
                <Divider light />
                <br/>
                <br/>
                <Typography align="left" variant="h6">{languageStrings.registrationLinkExpired.title}</Typography>
                <br/>
                <Typography align="center">
                    {languageStrings.registrationLinkExpired.description}<Link style={{ color: '#3f51b5', fontWeight: '500' }} href={generalRegistrationURL}>{languageStrings.registrationLinkExpired.here}</Link>.
                </Typography>
                <br/>
                <br/>
                <br/>
                <br/>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={e => {
                        const win = window.open("about:blank", "_self");
                        if(win)
                            win.close();
                    }}
                >
                    close
                </Button>
            </Paper>
            <Footer languageStrings={languageStrings} />
        </div>
    );
}

export default RegistrationLinkInfo;